module.exports = __webpack_public_path__ + "img/paypay.598b5328.jpg";